/*
 * @Author: JinpengFeng
 * @Date: 2020-06-22 04:07:29
 * @LastEditTime: 2021-01-13 14:46:01
 * @Description: 
 * @LastEditors: JinpengFeng
 */
/**
 * 类型集合
 */
export const APP_CLICK = "APP_CLICK";
export const DEMO1_CLICK = "DEMO1_CLICK";
export const DEMO1_CHILD_CLICK = "DEMO1_CHILD_CLICK";
export const DEMO2_CLICK = "DEMO2_CLICK";

/**
 * 首页-搜索-searchTitle
 */

export const SET_HOTLABELS = "SET_HOTLABELS";
export const UPDATE_LABELS = "UPDATE_LABELS";
export const SET_SELECTEDLABEL = "SET_SELECTEDLABEL";
export const SET_SEARCHNAME = "SET_SEARCHNAME";
